import React from "react";
import { DirectDebtPaymentMethodChangeFormData } from "src/schemas/DirectDebtFormSchema";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";
import EditAccountForm from "./EditAccountForm";

interface EditAccountModalProps {
  isOpen: boolean;
  accountData: DirectDebtPaymentMethodChangeFormData;
  onCancel: () => void;
  onSave: (updatedData: DirectDebtPaymentMethodChangeFormData) => void;
}

const EditAccountModal: React.FC<EditAccountModalProps> = ({
  isOpen,
  accountData,
  onCancel,
  onSave,
}) => (
  <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
    <DialogContent hideCloseButton>
      <DialogHeader>
        <DialogTitle>Editar dados bancários</DialogTitle>
      </DialogHeader>
      <EditAccountForm
        accountData={accountData}
        onCancel={onCancel}
        onSave={onSave}
      />
    </DialogContent>
  </Dialog>
);

export default EditAccountModal;
